@if (menuItems()) {
  <div [class.is-any-link-active]="anyActiveLink" class="trigger" [matMenuTriggerFor]="menu">
    <ng-content></ng-content>
  </div>
  <mat-menu #menu="matMenu">
    @for (menuItem of menuItems()!; track menuItem.transId) {
      <button
        #menuButton
        mat-menu-item
        routerLinkActive="active"
        [routerLink]="menuItem.route"
        (click)="openHelp(menuItem)">
        <mat-icon>{{ menuItem.icon }}</mat-icon>
        <span>{{ menuItem.text }}</span>
      </button>
    }
  </mat-menu>
}
